export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 flex items-center justify-center bg-primary-100 rounded-2xl">
            <i className="ri-mail-send-line text-2xl md:text-3xl text-primary-500"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">投稿爆料</h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
            你有独家的明星大瓜或吃瓜现场视频？欢迎投稿爆料！我们为每一位瓜友提供最快速的曝光通道，你的爆料可能成为明天的头条大瓜。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <div className="flex items-center gap-2 px-5 py-3 bg-background-50 border border-background-200 rounded-lg text-foreground-700 text-sm">
              <i className="ri-mail-line text-primary-500"></i>
              <span>tougao@meirichigua.com</span>
            </div>
            <a
              href="#contact"
              className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg transition-colors text-sm cursor-pointer"
            >
              <i className="ri-send-plane-line w-4 h-4 flex items-center justify-center"></i>
              立即投稿
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}